import React from 'react';
import IconButton from './IconButton';

const TickButton = ({ disabled, onClick }) => (
  <IconButton
    className="aridhia-tick-button"
    disabled={disabled}
    iconName="check"
    iconClassName="primary"
    iconOnly
    messageId="actions.confirm"
    onClick={onClick}
  />
);

export default TickButton;
